function RRConfig($window) {
	const rrSettings = $window.config;
	return {
		apiKey: rrSettings.RR_API_KEY,
		sessionId: $window.SessionId,
		url: rrSettings.RR_API_URL
	};
}

module.exports = RRConfig;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-config.js
 **/